import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBrain } from "@fortawesome/free-solid-svg-icons";

import { COURSE_MESSAGES } from "../messages";
import { getDifficultyLabel } from "../../../shared/constants/courseContent";

interface CourseDifficultyProps {
    difficulty?: number;
}

// "Course level: Beginner" line. Renders nothing for unknown levels.
const CourseDifficulty = ({ difficulty }: CourseDifficultyProps) => {
    const label = getDifficultyLabel(difficulty);
    if (!label) return null;

    return (
        <div className="flex items-center gap-2 text-gray-700">
            <FontAwesomeIcon icon={faBrain} />
            <span>{COURSE_MESSAGES.difficultyLabel}</span>
            <strong>{label}</strong>
        </div>
    );
};

export default CourseDifficulty;